import merge from 'lodash/merge'

import { type TemplateData } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import { TextBlockModule } from '../blocks/TextSection'
import { type SmsSectionCreate, type CampaignResourceCreate } from '../types'
const i18n = i18nPlugin.global

export const blankTemplate = async (
  brandId: string
): Promise<TemplateData<CampaignResourceCreate, SmsSectionCreate>> => ({
  blocks: [
    merge(
      TextBlockModule.createData({
        brandId,
        type: 'text',
      }),
      {
        data: null,
      }
    ),
  ],
  resource: {
    brandId,
    locationId: null,
    name: i18n.t('text-builder.defaults.blank.name'),
    sections: [],
  },
})
